import { Briefcase, Rocket, Compass, Lock, Sparkles, Coins } from "lucide-react";

export const TOPICS = [
  { id: "beruf-karriere", label: "Beruf & Karriere", icon: Briefcase, desc: "Dein Weg im Job & deine nächsten Schritte" },
  { id: "selbststaendigkeit", label: "Selbständigkeit & Business", icon: Rocket, desc: "Gründung, Wachstum & unternehmerische Kraft" },
  { id: "berufung", label: "Berufung & Lebensweg", icon: Compass, desc: "Deine innere Bestimmung & dein Seelenweg" },
  { id: "blockaden", label: "Blockaden im Beruf", icon: Lock, desc: "Was dich zurückhält & wie du es löst" },
  { id: "erfolg", label: "Erfolg & Sichtbarkeit", icon: Sparkles, desc: "Anerkennung, Bühne & Durchbruch" },
  { id: "geldfluss", label: "Geldfluss & Fülle", icon: Coins, desc: "Finanzielle Energie & dein Wohlstand" },
];

export const SPREADS = [
  {
    id: "drei",
    label: "3-Karten-Legung",
    subtitle: "Energie – Blockade – Entwicklung",
    positions: ["Energie", "Blockade", "Entwicklung"],
  },
  {
    id: "fuenf",
    label: "5-Karten-Legung",
    subtitle: "Jetzt – Blockade – Chance – Weg – Ergebnis",
    positions: ["Jetzt", "Blockade", "Chance", "Weg", "Ergebnis"],
  },
  {
    id: "neun",
    label: "9-Karten-Legung",
    subtitle: "Tiefe Analyse für Beruf & Selbständigkeit",
    positions: ["Ausgangslage", "Stärke", "Herausforderung", "Verborgenes", "Umfeld", "Chance", "Hindernis", "Empfehlung", "Ergebnis"],
  },
  {
    id: "grosses-blatt",
    label: "Großes Blatt – Beruf & Selbständigkeit",
    subtitle: "Alle Themen im Überblick",
    positions: ["Berufung", "Aktuelle Lage", "Stärken", "Blockaden", "Finanzen", "Sichtbarkeit", "Chancen", "Nächster Schritt", "Ergebnis"],
  },
  {
    id: "thema-berufung",
    label: "Themenlegung Berufung",
    subtitle: "Deine innere Bestimmung",
    positions: ["Deine Gabe", "Was dich ruft", "Was dich hält", "Dein Weg"],
  },
  {
    id: "thema-selbststaendigkeit",
    label: "Themenlegung Selbständigkeit",
    subtitle: "Dein unternehmerischer Weg",
    positions: ["Geschäftsidee", "Stärke", "Risiko", "Geldfluss", "Erfolg"],
  },
  {
    id: "thema-blockaden",
    label: "Themenlegung Blockaden",
    subtitle: "Was dich hemmt & wie du es löst",
    positions: ["Die Blockade", "Ursprung", "Auswirkung", "Lösung"],
  },
  {
    id: "thema-erfolg",
    label: "Themenlegung Erfolg & Sichtbarkeit",
    subtitle: "Dein Weg ins Licht",
    positions: ["Deine Sichtbarkeit", "Was dich zurückhält", "Deine Bühne", "Der Durchbruch", "Erfolg"],
  },
];

export const DECK_OPTIONS = [
  { id: "lenormand", label: "Lenormand", desc: "Klar, direkt & präzise – ideal für Beruf, Business & Entscheidungen." },
  { id: "tarot", label: "Tarot", desc: "Tief, archetypisch & seelenvoll – ideal für Berufung & innere Entwicklung." },
];
